import { atom } from 'jotai';
import { useAtomValue } from 'jotai/react';

export const isPageVisibleAtom = atom(true);

export const usePageVisible = () => {
  const isPageVisible = useAtomValue(isPageVisibleAtom);
  return isPageVisible;
};
